




import { defineComponent, onBeforeUnmount, ref } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import ConfirmSensitiveContent from "@/components/ConfirmSensitiveContent";

export default defineComponent({
  name: "SensitiveContentGate",
  components: {
    ConfirmSensitiveContent,
  },
  inheritAttrs: false,
  setup() {
    const forceShow = ref(false);
    const visible = ref(false);

    const onRequest = (show = false) => {
      visible.value = true;
      forceShow.value = show;
    };
    const onResolve = () => {
      visible.value = false;
      forceShow.value = false;
    };

    emitter.on(EVENTS.SENSITIVE_CONTENT_GATE_REQUEST, onRequest);

    onBeforeUnmount(() => {
      emitter.off(EVENTS.SENSITIVE_CONTENT_GATE_REQUEST, onRequest);
    });
    return {
      visible,
      forceShow,
      onResolve,
    };
  },
});
